import { useState } from 'react';
import productMasterModel from '../product/ProductMaster.model';

const QuoteModel = () => {
  const initialState = {
    id: 0,
    mainProduct: productMasterModel().initialState,
    mainProductQuantity: 1,
    mainProductUnitDiviser: 1,
    mainProductQuotePrice: null,
    mainProductJaybelExcGstPrice: null,
    mainProductJaybelExcGstPriceTotal: null,
    mainProductCurrentSupplierExcGstPrice: null,
    mainProductCurrentSupplierGp: null,
    mainProductCurrentSupplierExcGstTotal: null,
    mainProductGpRequired: null,
    mainProductSaving: null,
    mainProductTotal: null,
    alternateProduct: productMasterModel().initialState,
    alternateProductQuantity: 1,
    alternateProductUnitDiviser: 1,
    alternateProductQuotePrice: null,
    alternateProductJaybelExcGstPrice: null,
    alternateProductJaybelExcGstPriceTotal: null,
    alternateProductCurrentSupplierExcGstPrice: null,
    alternateProductCurrentSupplierGp: null,
    alternateProductCurrentSupplierExcGstTotal: null,
    alternateProductGpRequired: null,
    alternateProductSaving: null,
    alternateProductTotal: null,
    comment: '',
    mainProductCurrentSupplierIncGstPrice: null,
    alternateProductCurrentSupplierIncGstPrice: null,
    mainProductJaybelIncGstPrice: null,
    alternateProductJaybelIncGstPrice: null,
    mainProductJaybelIncGstPriceTotal: null,
    alternateProductJaybelIncGstPriceTotal: null,
    mainProductCurrentSupplierIncGstPriceTotal: null,
    alternateProductCurrentSupplierIncGstPriceTotal: null,
  };
  const [quote, setQuote] = useState(initialState);

  return {
    quote,
    setQuote,
    initialState,
  };
};

export default QuoteModel;
